var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRandom = function SvgIconRandom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#d4d4d4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M4 14.701h1.863c.727 0 1.409-.375 1.831-1.006l.64-.956m7.2-6.48h-1.862c-.727 0-1.409.375-1.831 1.006l-.716 1.07M14.436 4.5 16 6.26l-1.564 1.759m0 4.963L16 14.74 14.436 16.5M4 6.53h1.863c.727 0 1.409.376 1.831 1.007l4.147 6.198c.422.631 1.104 1.006 1.83 1.006h1.864"
  })));
};
export default SvgIconRandom;